import '@ojp/ojp-elements';
import '@smartimpact-it/better-select/dist/autoRegisterWebComponent';
import {OjpRow} from '@ojp/ojp-elements/dist/components/ojp-row';
import {OjpCol} from '@ojp/ojp-elements/dist/components/ojp-col';
import {ToastMessage} from './modules/toast-message';
import {OjpAccordion} from '@ojp/ojp-elements/dist/components/ojp-accordion';
import {OjpAccordionItem} from '@ojp/ojp-elements/dist/components/ojp-accordion-item';
import {OjpModal} from '@ojp/ojp-elements/dist/components/ojp-modal';
import {Customizer} from './utils/customizer';
import {ModelInfoModal} from './modules/model-info-modal';
import {Utils} from './utils/utils';
import * as Sentry from '@sentry/browser';
import {AlertDialog} from './utils/alert-dialog';


function main() {

    initSentryMonitoring();
    initGlobalFunctions();
    initImpersonationExpiredToast();
    initFlashToast();

    // select all anchor tags with an href attribute that starts with #
    const anchorLinks = document.querySelectorAll('a[href^="#"]');
    anchorLinks.forEach((anchorLink) => {
        anchorLink.addEventListener('click', (e) => {
            e.preventDefault();
            const selector = anchorLink.getAttribute('href');
            if(selector === '#') {
                return
            };
            const target = document.querySelector(anchorLink.getAttribute('href'));
            if (target) {
                // set a scroll margin of 100px
                target.style.scrollMarginTop = '100px';
                target.scrollIntoView({ behavior: 'smooth' });
            }
        });
    });

    const mainFooterRoot = document.querySelector('.main-footer');
    if (mainFooterRoot) {
        import('./modules/main-footer').then(({MainFooter}) => {
            window.mainFooter = new MainFooter(mainFooterRoot);
        });
    }

    const socialFeedRoots = document.querySelectorAll('.social-feed');
    window.socialFeeds = [];
    socialFeedRoots.forEach((socialFeedRoot) => {
        import('./modules/social-feed').then(({SocialFeed}) => {
            window.socialFeeds.push(new SocialFeed(socialFeedRoot));
        });
    });

    const valuesCalloutRoots = document.querySelectorAll('.values-callout');
    window.valuesCallouts = [];
    valuesCalloutRoots.forEach((valuesCalloutRoot) =>{
        import('./modules/values-callout').then(({ValuesCallout}) => {
            window.valuesCallouts.push(new ValuesCallout(valuesCalloutRoot));
        });
    });

    const breadcrumbsRoot = document.querySelector('.breadcrumbs');
    if (breadcrumbsRoot) {
        import('./modules/breadcrumbs').then(({Breadcrumbs}) => {
            window.breadcrumbs = new Breadcrumbs(breadcrumbsRoot);
        });
    }

    const bannerRoot = document.querySelector('.site-banner');
    if (bannerRoot) {
        import('./modules/banner').then(({Banner}) => {
            window.banner = new Banner(bannerRoot);
        });
    }

    // Handle elements with data-href attribute as links.
    // Used primarily for cards
    const navigableEls = document.querySelectorAll('[data-href]');
    if (navigableEls) {
        import('./utils/utils').then(({Utils}) => {
            navigableEls.forEach((el) => {
                const hasTargetParent = el.querySelector('a[target="_parent"]');
                Utils.handleNavigableEls(el, hasTargetParent ? true : false);
            });
        });
    }

    const pdpSection = document.querySelector('.pdp-section');
    if (pdpSection) {
        import('./modules/pdp-section').then(({PdpSection}) => {
            window.pdpSection = new PdpSection(pdpSection);
        });
    }

    const orderBlanks = document.querySelector('.order-blanks');
    if (orderBlanks) {
        import('./modules/order-blanks').then(({OrderBlanks}) => {
            window.orderBlanks = new OrderBlanks(orderBlanks);
        });
    }

    const quickOrderDecorations = document.querySelector('.quick-order-decoration');
    if (quickOrderDecorations) {
        import('./dashboard/quick-order-decorations').then(({QuickOrderDecorations}) => {
            window.quickOrderDecorations = new QuickOrderDecorations(quickOrderDecorations);
        });
    }

    const quickOrderBlanks = document.querySelector('.quick-order-blanks');
        if (quickOrderBlanks) {
            import('./modules/quick-order-blanks').then(({QuickOrderBlanks}) => {
                window.quickOrderBlanks = new QuickOrderBlanks(quickOrderBlanks);
            });
    }

    const productRowRoots = document.querySelectorAll('.product-row');
    window.productRows = [];
    productRowRoots.forEach((productRowRoot) => {
        import('./modules/product-row').then(({ProductRow}) => {
            window.productRows.push(new ProductRow(productRowRoot));
        });
    });

    const customizerSearchGridRoots = document.querySelectorAll('.customizer-search-grid');
    window.customizerSearchGrids = [];
    customizerSearchGridRoots.forEach((customizerSearchGridRoot) => {
        import('./modules/customizer-search-grid').then(({CustomizerSearchGrid}) => {
            window.customizerSearchGrids.push(new CustomizerSearchGrid(customizerSearchGridRoot));
        });
    });

    const fullBleedMediaRoots = document.querySelectorAll('.fullbleed-media');
    window.fullBleedMedia = [];
    fullBleedMediaRoots.forEach((fullBleedMediaRoot, index) => {
        import('./modules/fullbleed-media').then(({FullbleedMedia}) => {
            window.fullBleedMedia.push(new FullbleedMedia(fullBleedMediaRoot));
        });
    });

    const heroRoots = document.querySelectorAll('.hero');
    window.hero = [];
    heroRoots.forEach((heroRoot, index) => {
        import('./modules/hero').then(({Hero}) => {
            window.hero.push(new Hero(heroRoot));
        });
    });

    const dealerLocatorRoots = document.querySelectorAll('.dealer-locator');
    window.dealerLocators = [];
    dealerLocatorRoots.forEach((dealerLocatorRoot, index) => {
        import('./modules/dealer-locator').then(({DealerLocator}) => {
            window.dealerLocators.push(new DealerLocator(dealerLocatorRoot));
        });
    });

    const searchPageRoot = document.querySelector('main.search');
    if (searchPageRoot) {
        import('./modules/search-page').then(({SearchPage}) => {
            window.searchPage = new SearchPage(searchPageRoot);
        });
    }

    const navigationRoot = document.querySelector('#main-navigation');
    if(navigationRoot) {
        import('./modules/main-navigation').then(({MainNavigation}) => {
            window.mainNavigation = new MainNavigation(navigationRoot);
        });
    }

    const filteredGridRoots = document.querySelectorAll('#content > .filtered-grid');
    window.filteredGrids = [];
    filteredGridRoots.forEach((filteredGridRoot) => {
        import('./modules/filtered-grid').then(({FilteredGrid}) => {
            window.filteredGrids.push(new FilteredGrid(filteredGridRoot));
        });
    });

    const loginFormRoots = document.querySelectorAll('.login-form-container');
    window.loginForms = [];
    loginFormRoots.forEach((loginFormRoot, index) => {
        import('./forms/login-form').then(({LoginForm}) => {
            window.loginForms.push(new LoginForm(loginFormRoot));
        });
    });

    const forgotPasswordFormRoots = document.querySelectorAll('.forgot-password-form-container');
    window.forgotPasswordForms = [];
    forgotPasswordFormRoots.forEach((forgotPasswordFormRoot, index) => {
        import('./forms/forgot-password-form').then(({ForgotPasswordForm}) => {
            window.forgotPasswordForms.push(new ForgotPasswordForm(forgotPasswordFormRoot));
        });
    });

    const createAccountFormRoots = document.querySelectorAll('.create-account-form-container');
    window.createAccountForms = [];
    createAccountFormRoots.forEach((createAccountFormRoot, index) => {
        import('./forms/create-account-form').then(({CreateAccountForm}) => {
            window.createAccountForms.push(new CreateAccountForm(createAccountFormRoot));
        });
    });

    const resetPasswordFormRoots = document.querySelectorAll('.reset-password-form-container');
    window.resetPasswordForms = [];
    resetPasswordFormRoots.forEach((resetPasswordFormRoot, index) => {
        import('./forms/reset-password-form').then(({ResetPasswordForm}) => {
            window.resetPasswordForms.push(new ResetPasswordForm(resetPasswordFormRoot));
        });
    });

    const fullScreenProgressRoot = document.querySelector('.full-screen-progress-logo');
    if (fullScreenProgressRoot) {
        import('./modules/richardson-logo-letters').then(({RichardsonLogoLetters}) => {
            window.fullScreenProgress = new RichardsonLogoLetters(fullScreenProgressRoot);
        });
    }

    const accordionModuleRoots = document.querySelectorAll('.accordion-module');
    window.accordionModules = [];
    accordionModuleRoots.forEach((accordionModuleRoot) => {
        import('./modules/accordion-module').then(({AccordionModule}) => {
            window.accordionModules.push(new AccordionModule(accordionModuleRoot));
        });
    });

    const dashboardPage = document.querySelector('.dashboard-page');
    if (dashboardPage) {
        import('./dashboard/dashboard-page').then(({DashboardPage}) => {
            window.dashboardPage = new DashboardPage(dashboardPage);
        });
    }

    const dashboardQuickReorderRoot = document.querySelector('.quick-reorder');
    if (dashboardQuickReorderRoot) {
        import('./dashboard/dashboard-quick-reorder').then(({DashboardQuickReorder}) => {
            window.dashboardQuickReorder = new DashboardQuickReorder(dashboardQuickReorderRoot);
        });
    }

    const textMediaRoots = document.querySelectorAll('.text-media');
    window.textMedias = [];
    textMediaRoots.forEach((textMediaRoot) => {
        import('./modules/text-media').then(({TextMedia}) => {
            window.textMedias.push(new TextMedia(textMediaRoot));
        });
    });

    const dealerLocatorPageRoot = document.querySelector('.dealer-locator-page');
    if (dealerLocatorPageRoot) {
        import('./modules/dealer-locator-page').then(({DealerLocatorPage}) => {
            window.dealerLocatorPage = new DealerLocatorPage(dealerLocatorPageRoot);
        });
    }

    const shoppingCartRoot = document.querySelector('#shopping-cart');
    if (shoppingCartRoot) {
        import('./modules/shopping-cart').then(({ShoppingCart}) => {
            window.shoppingCart = new ShoppingCart(shoppingCartRoot);
        });
    }

    const checkoutRoot = document.querySelector('#checkout');
    if (checkoutRoot) {
        import('./shopping-cart/checkout').then(({Checkout}) => {
            window.checkoutPage = new Checkout(checkoutRoot);
        });
    }

    const tooltips = document.querySelectorAll('button.tooltip');
    window.tooltips = [];
    tooltips.forEach((tooltip) => {
        import('./modules/tooltip').then(({Tooltip}) => {
            window.tooltips.push(new Tooltip(tooltip));
        });
    });

    const estimatorPageRoot = document.querySelector('.shipping-estimator-page');
    if (estimatorPageRoot) {
        import('./modules/shipping-estimator-page').then(({ShippingEstimatorPage}) => {
            window.estimatorPage = new ShippingEstimatorPage(estimatorPageRoot);
        });
    }
}

function initGlobalFunctions() {
    let scrollY = null;

    window.setScrollLock = function (lock) {
        if (lock) {
            if(scrollY !== null) return

            scrollY = window.scrollY;
            document.body.style.position = 'fixed';
            document.body.style.overflow = 'hidden';
            document.body.style.left = '0px';
            document.body.style.right = '0px';
            document.body.style.top = `-${scrollY}px`;
        } else {
            if(scrollY === null) return;

            document.body.style.position = '';
            document.body.style.overflow = '';
            document.body.style.left = '';
            document.body.style.right = '';
            document.body.style.scrollBehavior = 'auto';
            document.body.style.top = '';
            window.scrollTo({
                behavior: 'auto',
                top: scrollY,
            });

            requestAnimationFrame(() => {
                scrollY = null;
            });
        }
    }

    window.performLogin = (redirectUrl = null) => {
        const loginModal = document.querySelector('#login-modal');
        if(!loginModal) return;

        loginModal.openModal();

        const loginForm = window.loginForms[0] || null;
        if(!loginForm) return;

        loginForm.skipRedirect = true;
        return new Promise((resolve, reject) => {
            loginForm.root.addEventListener('login-success-customizer', (e) => {
                resolve(true);
                loginModal.closeModal();

                if(redirectUrl) {
                    window.location.href = redirectUrl;
                }
            });
            loginForm.root.addEventListener('login-failed', (e) => {
                resolve(false);
            });
            loginForm.root.addEventListener('login-error', (e) => {
                reject(e.detail);
            });
        });
    }

    window.toggleInfoModal = (isVisible, model) => {
        const infoModal = document.querySelector('#model-info-modal');
        if(!infoModal) return;

        const modal = new ModelInfoModal(infoModal);

        if(isVisible) {
            modal.loadModel(model);
        } else {
            infoModal.closeModal();
        }
    }

    window.toggleLoading = (isLoading) => {
        Utils.toggleFullScreenProgress(isLoading);
    }

    window.showAlertDialog = (title, message, confirmText = 'OK', cancelText = 'Cancel') => {
        return AlertDialog.show(title, message, confirmText, cancelText);
    }

    window.toggleModelSelector = (show) => {
        const modelSelector = document.querySelector('#model-selector-modal');
        if(!modelSelector) return;

        if(show) {
            modelSelector.openModal();
            // ojp-modal redirects the *first* focusin its dialog receives after
            // opening to its own close button (an accessibility focus-trap).
            // Focus moving into any iframe still fires a normal, bubbling
            // focusin on the iframe element itself in this parent document, so
            // the Model Selector's iframe is a likely candidate to trigger that
            // redirect the moment the user interacts with it. Consume that
            // one-time trigger ourselves immediately, before the iframe does.
            const closeButton = modelSelector.shadowRoot && modelSelector.shadowRoot.querySelector('.close-button');
            if(closeButton) {
                closeButton.focus();
            }
        } else {
            modelSelector.closeModal();
        }
    }

    window.showToastMessage = (message, icon = null, action = 'Dismiss', actionCallback = null) => {
        ToastMessage.show({
            message,
            icon,
            action,
            actionCallback
        });
    }
}

function initFlashToast() {
    const raw = sessionStorage.getItem('flashToast');
    if (!raw) {
        return;
    }
    sessionStorage.removeItem('flashToast');
    ToastMessage.show(JSON.parse(raw));
}

function initImpersonationExpiredToast() {
    if (!window.wp_ajax || window.wp_ajax.IMPERSONATION_NOTICE !== 'expired') {
        return;
    }

    ToastMessage.show({
        message: 'Your impersonation session expired. You are now back in your account.',
        icon: 'alert',
    });
}

function initSentryMonitoring() {
    if(!window.wp_ajax || !window.wp_ajax.ENVIRONMENT) {
        return;
    }

    const allowedEnvironments = ['production', 'staging'];
    if (!allowedEnvironments.includes(window.wp_ajax.ENVIRONMENT)) {
        return;
    }

    // The Model Selector's iframe runs sandboxed without allow-same-origin
    // (set by a third-party bundle we don't control), giving it a null/opaque
    // origin. Sentry's Replay and Browser Tracing integrations touch
    // sessionStorage/localStorage during init, which throws under that origin.
    // Since this is the first call in main(), an uncaught throw here would
    // abort every subsequent initialization step on the page.
    try {
    Sentry.init({
        dsn: "https://e9cfce218bd0e22963cb1cd93a9e5894@o4506074179174400.ingest.us.sentry.io/4508107067490304",
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        environment: window.wp_ajax.ENVIRONMENT,
        release: window.wp_ajax.SENTRY_RELEASE || 'unknown',
        allowUrls: [
            'richardsonsports.com',
            'richardsonnext.wpenginepowered.com',
            'richardsonsdev.wpenginepowered.com',
        ],
        sampleRate: 0.2,
        replaysSessionSampleRate: 0.1,
        tracesSampleRate: 0.1,
        tracePropagationTargets: [
            new RegExp('^https?:\\/\\/richardsonsports\\.com(?:\\/|$)', 'i'),
            new RegExp('^https?:\\/\\/(?:[a-z0-9-]+\\.)+richardsonsports\\.com(?:\\/|$)', 'i'),
        ],
        ignoreErrors: [
            // Random plugins/extensions
            'top.GLOBALS',
            // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
            'originalCreateNotification',
            'canvas.contentDocument',
            'MyApp_RemoveAllHighlights',
            'http://tt.epicplay.com',
            'Can\'t find variable: ZiteReader',
            'jigsaw is not defined',
            'ComboSearch is not defined',
            'http://loading.retry.widdit.com/',
            'atomicFindClose',
            // Facebook borked
            'fb_xd_fragment',
            // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
            // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
            'bmi_SafeAddOnload',
            'EBCallBackMessageReceived',
            // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
            'conduitPage',
            // Generic error code from errors outside the security sandbox
            // You can delete this if using raven.js > 1.0, which ignores these automatically.
            'Script error.',
            'Event `CustomEvent` (type=error) captured as exception',
            "The play() request was interrupted by",
            "play() failed because the user",
            "The fetching process for the media resource was aborted by the user agent at the user's request",
            "not allowed by the user agent or the platform in the current context, possibly because the user denied permission",
            "The URL is not available because of the video's privacy settings",
            "plyr/dist/plyr",
            "maps/api/js",
            "ResizeObserver loop completed with undelivered notifications",
            "roof-designer",
            "api/player",
            "Unexpected token '...'. Expected a property name",
            "player.embed.getVideoUrl"
        ],
        denyUrls: [
            // Ignore customizer pages and subpaths (RegExp() avoids /…/ parsing issues when minified)
            new RegExp('\\/customizer(?:\\/|$)', 'i'),
            new RegExp('graph\\.facebook\\.com', 'i'),
            new RegExp('connect\\.facebook\\.net\\/en_US\\/all\\.js', 'i'),
            new RegExp('eatdifferent\\.com\\.woopra-ns\\.com', 'i'),
            new RegExp('static\\.woopra\\.com\\/js\\/woopra\\.js', 'i'),
            new RegExp('extensions\\/', 'i'),
            new RegExp('^chrome:\\/\\/', 'i'),
            new RegExp('127\\.0\\.0\\.1:4001\\/isrunning', 'i'),
            new RegExp('webappstoolbarba\\.texthelp\\.com\\/', 'i'),
            new RegExp('metrics\\.itunes\\.apple\\.com\\.edgesuite\\.net\\/', 'i'),
        ]
    });
    } catch (e) {
        console.error('Sentry initialization failed', e);
    }
}

// Run main in both normal and deferred-loading scenarios.
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', main, {once: true});
} else {
    main();
}
